import giftCardBannerSrc from "media/photos/wallet/gift-card-banner.png";

export const sliderImages = [giftCardBannerSrc];
